module.exports = __webpack_public_path__ + "img/nothig-img.4e613198.png";